import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Playlist from '../../models/playlist';
import LeaveBehindList from './leave-behind-list';
import LeaveBehindReplay from './leave-behind-replay';
import './leave-behind.scss';

class LeaveBehind extends Component {

    constructor(props) {

        super(props);
        this.state = { countdown: props.countdown };

    }

    render() {

        const {
            playlist,
            onSelectItem,
            type,
        } = this.props;
        const { countdown } = this.state;
        const selected = playlist.getSelectedItem() || {};
        const listProps = {
            playlist,
            countdown,
            onSelectItem,
        };
        const replay = () => onSelectItem(selected);

        return (
            <div className="leave-behind">
                <header className="leave-behind-header">
                    <h1 className="title">Just Watched: {selected.title}</h1>
                    <small className="actions">
                        <span onClick={replay} className="replay-action">Replay: <i className="media-icon media-icon--recap"></i></span>
                    </small>
                </header>
                <section className="content">
                    { type === 'list' ? (<LeaveBehindList {...listProps} />) : (<LeaveBehindReplay onClick={replay} />) }
                </section>
            </div>
        );

    }

}

LeaveBehind.propTypes = {
    playlist: PropTypes.instanceOf(Playlist),
    countdown: PropTypes.number,
    onSelecItem: PropTypes.func,
    type: PropTypes.string,
};

LeaveBehind.defaultProps = {
    playlist: new Playlist([]),
    onSelectItem: () => null,
    countdown: 7,
    type: 'list',
};

export default LeaveBehind;
